import * as moment from 'moment';
import {
    IDailyDataRequest,
    IDataValueApi,
    IDailyDataParams
} from '../../api/data-value-api.service';
import {IParsedTelegramData} from './telegram.controller';
import {IDischargeModel} from '../../api/api.types'

export interface ITelegramComparisonData {
  comparisonData: IComparisonData,
  actions: {
    hqAdjustment: boolean,
    entryCorrection: boolean,
    waterLevelTrend: boolean,
    icePhenomena: boolean
  },
  calculatedTelegramData: IDailyDataParams,
  parsedTelegramData: IParsedTelegramData
}

export interface ITelegramComparisonDataRow {
  fieldName:string,
  label:string,
  newValue: any, 
  oldValue: any, 
  overrideData: boolean,
  manualInputValue?: any
}

export interface ITelegramComparisonDailyDataPart {
  newWaterLevel: number,
  newDischarge: number,
  oldWaterLevel: number,
  oldDischarge: number,
  overrideWaterLevelData: boolean,
  overrideDischargeData: boolean
}

export interface ITelegramComparsionDailyDataRow {
  date: moment.Moment;
  morningCell?: ITelegramComparisonDailyDataPart;
  eveningCell?: ITelegramComparisonDailyDataPart;
  averageCell?: ITelegramComparisonDailyDataPart;
}

export interface IComparisonData {
  dailyData: ITelegramComparsionDailyDataRow[],
  dischargeDataRows: ITelegramComparisonDataRow[],
  meteoDataRows: ITelegramComparisonDataRow[],
  icePhenomenaeDataRowsList: ITelegramComparisonDataRow[][]
}

export class TelegramDataComparisonService {

	constructor() {

	}

	// receives data from telegram and data from database
	// and formats it for comparison
	public formatDataForTelegramProcessing(newEntry: IDailyDataParams, oldEntry: IDailyDataParams) {
	  let formattedDischargeDataForTelegramProcessing:ITelegramComparisonDataRow[] = [];
	  let formattedMeteoDataForTelegramProcessing:ITelegramComparisonDataRow[] = [];
	  let formattedIceDataForTelegramProcessing:ITelegramComparisonDataRow[][] = [];
	  let formattedDailyDataForTelegramProcessing:ITelegramComparsionDailyDataRow[] = [];

	  if (newEntry.dischargeData && oldEntry.dischargeData) {
		  // daily data
		  if (
		      newEntry.dischargeData.dailyData && oldEntry.dischargeData.dailyData
		  ) {
		    
		    newEntry.dischargeData.dailyData.forEach((newEntryDailyDataRow, index) => {
		      let dailyDataRow: ITelegramComparsionDailyDataRow = {
		        date: null,
		        morningCell: {
		          newWaterLevel: null,
		          newDischarge: null,
		          oldWaterLevel: null,
		          oldDischarge: null,
		          overrideWaterLevelData: true,
		          overrideDischargeData: true
		        },
		        eveningCell: {
		          newWaterLevel: null,
		          newDischarge: null,
		          oldWaterLevel: null,
		          oldDischarge: null,
		          overrideWaterLevelData: true,
		          overrideDischargeData: true
		        },
		        averageCell: {
		          newWaterLevel: null,
		          newDischarge: null,
		          oldWaterLevel: null,
		          oldDischarge: null,
		          overrideWaterLevelData: true,
		          overrideDischargeData: true
		        }
		      };
		      const oldDailyData = oldEntry.dischargeData.dailyData;

		      if (oldDailyData[index]) {

		      	let addDailyDataRow: boolean = false;
		        dailyDataRow.date = newEntryDailyDataRow.date;
		        // evening
		        if (newEntryDailyDataRow.eveningData) {
		          //new
		          dailyDataRow.eveningCell.newWaterLevel = newEntryDailyDataRow.eveningData.waterLevel;
		          dailyDataRow.eveningCell.newDischarge = newEntryDailyDataRow.eveningData.discharge;
		          //old
		          dailyDataRow.eveningCell.oldWaterLevel = 
		            oldDailyData[index].eveningData && oldDailyData[index].eveningData.waterLevel;
		          dailyDataRow.eveningCell.oldDischarge = 
		            oldDailyData[index].eveningData && oldDailyData[index].eveningData.discharge;

		          if (
		              newEntry.dischargeData && 
		              newEntry.dischargeData.icePhenomenae && newEntry.dischargeData.icePhenomenae.length
		          ) { // when ice phenomena defined, enable manual input for today and the previous day
		          		addDailyDataRow = true;
		          } else {
			          if (
			          	// 
			          	dailyDataRow.eveningCell.newWaterLevel != null && dailyDataRow.eveningCell.oldWaterLevel != null ||
			          	dailyDataRow.eveningCell.newDischarge != null && dailyDataRow.eveningCell.oldDischarge != null
			          ) {
			          	addDailyDataRow = true;
			          }
			      }
		        }
		        // morning
		        if (newEntryDailyDataRow.morningData) {
		          //new
		          dailyDataRow.morningCell.newWaterLevel = newEntryDailyDataRow.morningData.waterLevel;
		          dailyDataRow.morningCell.newDischarge = newEntryDailyDataRow.morningData.discharge;
		          //old
		          dailyDataRow.morningCell.oldWaterLevel = 
		            oldDailyData[index].morningData && oldDailyData[index].morningData.waterLevel;
		          dailyDataRow.morningCell.oldDischarge = 
		            oldDailyData[index].morningData && oldDailyData[index].morningData.discharge;

		          if (
		              newEntry.dischargeData && 
		              newEntry.dischargeData.icePhenomenae && newEntry.dischargeData.icePhenomenae.length
		          ) { // when ice phenomena defined, enable manual input for today and the previous day
		          		addDailyDataRow = true;
		          } else {
			          if (
			          	dailyDataRow.morningCell.newWaterLevel != null && dailyDataRow.morningCell.oldWaterLevel != null ||
			          	dailyDataRow.morningCell.newDischarge != null && dailyDataRow.morningCell.oldDischarge != null
			          ) {
			          	addDailyDataRow = true;
			          }
			      }
		        }
		        // average
		        if (newEntryDailyDataRow.averageData) {
		          //new
		          dailyDataRow.averageCell.newWaterLevel = newEntryDailyDataRow.averageData.waterLevel;
		          dailyDataRow.averageCell.newDischarge = newEntryDailyDataRow.averageData.discharge;
		          //old
		          dailyDataRow.averageCell.oldWaterLevel = 
		            oldDailyData[index].averageData && oldDailyData[index].averageData.waterLevel;
		          dailyDataRow.averageCell.oldDischarge = 
		            oldDailyData[index].averageData && oldDailyData[index].averageData.discharge;

		          if (
		              newEntry.dischargeData && 
		              newEntry.dischargeData.icePhenomenae && newEntry.dischargeData.icePhenomenae.length
		          ) { // when ice phenomena defined, enable manual input for today and the previous day
		          		addDailyDataRow = true;
		          } else {
		          	if (
		          		dailyDataRow.averageCell.newWaterLevel != null && dailyDataRow.averageCell.oldWaterLevel != null ||
		          		dailyDataRow.averageCell.newDischarge != null && dailyDataRow.averageCell.oldDischarge != null
		          	) {
		          		addDailyDataRow = true;
		          	}
		          }
		          
		        }
		        
		        if (addDailyDataRow) {
		        	formattedDailyDataForTelegramProcessing.push(dailyDataRow);
		        }
		        
		      }
		    });
		  }
		  // discharge data
		  if (
		      newEntry.dischargeData && 
		      newEntry.dischargeData.dischargeMeasurementData
		      &&
		      oldEntry.dischargeData && 
		      oldEntry.dischargeData.dischargeMeasurementData
		  ) {

		    // discharge
		    if (
		        newEntry.dischargeData.dischargeMeasurementData.discharge &&
		        oldEntry.dischargeData.dischargeMeasurementData.discharge
		    ) {
		      formattedDischargeDataForTelegramProcessing.push({
		        fieldName: 'discharge',
		        label: 'discharge',
		        newValue: newEntry.dischargeData.dischargeMeasurementData.discharge,
		        oldValue: oldEntry.dischargeData.dischargeMeasurementData.discharge,
		        overrideData: true,
		        manualInputValue: null
		      })
		    }
		    // waterlevel
		    if (
		        newEntry.dischargeData.dischargeMeasurementData.waterLevel &&
		        oldEntry.dischargeData.dischargeMeasurementData.waterLevel
		    ) {
		      formattedDischargeDataForTelegramProcessing.push({
		        fieldName: 'waterLevel',
		        label: 'waterLevel',
		        newValue: newEntry.dischargeData.dischargeMeasurementData.waterLevel,
		        oldValue: oldEntry.dischargeData.dischargeMeasurementData.waterLevel,
		        overrideData: true,
		        manualInputValue: null
		      })
		    }
		    // free river area
		    if (
		        newEntry.dischargeData.dischargeMeasurementData.freeRiverArea &&
		        oldEntry.dischargeData.dischargeMeasurementData.freeRiverArea
		    ) {
		      formattedDischargeDataForTelegramProcessing.push({
		        fieldName: 'freeRiverArea',
		        label: 'freeRiverArea',
		        newValue: newEntry.dischargeData.dischargeMeasurementData.freeRiverArea,
		        oldValue: oldEntry.dischargeData.dischargeMeasurementData.freeRiverArea,
		        overrideData: true,
		        manualInputValue: null
		      })
		    }
		    // maximum depth
		    if (
		        newEntry.dischargeData.dischargeMeasurementData.maximumDepth &&
		        oldEntry.dischargeData.dischargeMeasurementData.maximumDepth
		    ) {
		      formattedDischargeDataForTelegramProcessing.push({
		        fieldName: 'maximumDepth',
		        label: 'maximumDepth',
		        newValue: newEntry.dischargeData.dischargeMeasurementData.maximumDepth,
		        oldValue: oldEntry.dischargeData.dischargeMeasurementData.maximumDepth,
		        overrideData: true,
		        manualInputValue: null
		      })
		    }
		    // date
		    if (
		        newEntry.dischargeData.dischargeMeasurementData.date &&
		        oldEntry.dischargeData.dischargeMeasurementData.date
		    ) {
		      formattedDischargeDataForTelegramProcessing.push({
		        fieldName: 'date',
		        label: 'date',
		        newValue: newEntry.dischargeData.dischargeMeasurementData.date,
		        oldValue: moment.unix(<number>oldEntry.dischargeData.dischargeMeasurementData.date),
		        overrideData: true,
		        manualInputValue: null
		      })
		    }
		  }

		  // temperatures
		  if (
		      newEntry.dischargeData && 
		      newEntry.dischargeData.temperatures
		      &&
		      oldEntry.dischargeData && 
		      oldEntry.dischargeData.temperatures
		  ) {
		    if (
		        newEntry.dischargeData.temperatures.waterTemperature &&
		        oldEntry.dischargeData.temperatures.waterTemperature
		    ) {
		      formattedDischargeDataForTelegramProcessing.push({
		        fieldName: 'waterTemperature',
		        label: 'waterTemperature',
		        newValue: newEntry.dischargeData.temperatures.waterTemperature,
		        oldValue: oldEntry.dischargeData.temperatures.waterTemperature,
		        overrideData: true,
		        manualInputValue: null
		      })
		    }
		    if (
		        newEntry.dischargeData.temperatures.airTemperature &&
		        oldEntry.dischargeData.temperatures.airTemperature
		    ) {
		      formattedDischargeDataForTelegramProcessing.push({
		        fieldName: 'airTemperature',
		        label: 'airTemperature',
		        newValue: newEntry.dischargeData.temperatures.airTemperature,
		        oldValue: oldEntry.dischargeData.temperatures.airTemperature,
		        overrideData: true,
		        manualInputValue: null
		      })
		    }
		  }

		  // ice phenomena
		  if (
		      newEntry.dischargeData && 
		      newEntry.dischargeData.icePhenomenae
		      &&
		      oldEntry.dischargeData && 
		      oldEntry.dischargeData.icePhenomenae
		  ) {
		  	
		  	newEntry.dischargeData.icePhenomenae.forEach((iceDataItem, index) => {
		  		let icePhenomenaeDataRows: ITelegramComparisonDataRow[] = []
		  		icePhenomenaeDataRows.push({
		  		  fieldName: 'code',
		  		  label: 'Code',
		  		  newValue: iceDataItem.code,
		  		  oldValue: oldEntry.dischargeData.icePhenomenae[index] && oldEntry.dischargeData.icePhenomenae[index].code,
		  		  overrideData: true,
		  		  manualInputValue: null
		  		})
		  		icePhenomenaeDataRows.push({
		  		  fieldName: 'intensity',
		  		  label: 'Intensity',
		  		  newValue: iceDataItem.intensity,
		  		  oldValue: oldEntry.dischargeData.icePhenomenae[index] && oldEntry.dischargeData.icePhenomenae[index].intensity,
		  		  overrideData: true,
		  		  manualInputValue: null
		  		})

		  		formattedIceDataForTelegramProcessing.push(icePhenomenaeDataRows)
		  	})
		  }

		}

	  // meteo data
	  if (
	      newEntry.meteoData && oldEntry.meteoData
	  ) {
	    if (newEntry.meteoData.airTemp && oldEntry.meteoData.airTemp) {
	      formattedMeteoDataForTelegramProcessing.push({
	        fieldName: 'airTemperature',
	        label: 'airTemperature',
	        newValue: newEntry.meteoData.airTemp,
	        oldValue: oldEntry.meteoData.airTemp,
	        overrideData: true,
	        manualInputValue: null
	      })
	    }
	    if (newEntry.meteoData.precipitation && oldEntry.meteoData.precipitation) {
	      formattedMeteoDataForTelegramProcessing.push({
	        fieldName: 'precipitation',
	        label: 'precipitation',
	        newValue: newEntry.meteoData.precipitation,
	        oldValue: oldEntry.meteoData.precipitation,
	        overrideData: true,
	        manualInputValue: null
	      })
	    }
	  }

	  return {
	    dailyData: formattedDailyDataForTelegramProcessing,
	    dischargeDataRows: formattedDischargeDataForTelegramProcessing,
	    meteoDataRows: formattedMeteoDataForTelegramProcessing,
	    icePhenomenaeDataRowsList: formattedIceDataForTelegramProcessing
	  }
	}
}


/** WEBPACK FOOTER **
 ** ./app/operational/input/telegram-data-comparison.service.ts
 **/